import React, { useState, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Quiz from '../../components/Quiz';
import { useUpdateComponentState } from '../../../hooks';
import arrow from '../../../../../../assets/2025/arrow.gif';
import icon from '../../../../../../assets/education/cybersecurity/arrow-right-circle.png';

interface ISection1Props {
  settings: any;
}

interface Case {
  key: string;
  label: string;
  data: {
    num: number;
    title: string;
    list: string[];
  }[];
  labelActive: string;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const { quiz } = paragraphsSettings;
  const updateComponentState = useUpdateComponentState();
  const [state, setState] = useState({
    quiz: false,
  });

  const cases: Case[] = [
    {
      key: '1',
      label: paragraphsSettings.case1Title,
      data: paragraphsSettings.case1,
      labelActive: paragraphsSettings.case1Desc,
    },
    {
      key: '2',
      label: paragraphsSettings.case2Title,
      data: paragraphsSettings.case2,
      labelActive: paragraphsSettings.case2Desc,
    },
    {
      key: '3',
      label: paragraphsSettings.case3Title,
      data: paragraphsSettings.case3,
      labelActive: paragraphsSettings.case3Desc,
    },
  ];

  const [activeKey, setActiveKey] = useState('1');
  const activeCase = cases.find((c) => c.key === activeKey)!;

  // tab3的弹出模版展示
  const [clickCase, setClickCase] = useState(true);

  const [isShowArrowIcon, setIsShowArrowIcon] = React.useState(false);

  const clickTab = (n: string) => {
    if (n === '3') {
      setClickCase(true);
    }
    // 如果已经解锁了所有tab，则允许跳转到任意tab
    if (isShowArrowIcon) {
      setActiveKey(n);
      return;
    }

    // 按顺序跳转：只能跳转到下一个tab
    const currentIndex = cases.findIndex((c) => c.key === activeKey);
    const nextIndex = cases.findIndex((c) => c.key === n);

    // 只允许跳转到下一个tab
    if (nextIndex === currentIndex + 1) {
      setActiveKey(n);
      // 当跳转到tab2时，解锁所有tab
      if (n === '3') {
        setIsShowArrowIcon(true);
        updateComponentState(
          p_course,
          p_topic,
          ID,
          'education-cybersecurity-section2-1'
        );
      }
    }

    // 特殊情况：允许跳转到当前tab（用于重新选择）
    if (n === activeKey) {
      setActiveKey(n);
    }
  };

  return (
    <div className="topic-section-3 topic-section-3-en">
      <div
        className={`measure-tabs measure-tabs-${activeKey}`}
        id="education-cybersecurity-section2-1"
      >
        <div className="measure-tabs-con">
          {cases.map((c, index) => (
            <React.Fragment key={c.key}>
              {index < cases.length - 1 && !isShowArrowIcon && (
                <img
                  src={arrow}
                  alt=""
                  data-active={c.key === activeKey ? 'true' : 'false'}
                  className={`active-arrow active-arrow${
                    Number(activeKey) + 1
                  } ${activeKey === c.key ? `active-arrow-active` : ''}`}
                />
              )}
              <div
                className={`tab ${
                  activeKey === c.key ? 'active' : ''
                }  tab${Number(c.key)}`}
                onClick={() => clickTab(c.key)}
              >
                {activeKey === c.key ? (
                  <>
                    <div className="label-active">{c.label}</div>
                    <div className="label-active-desc">{c.labelActive}</div>
                  </>
                ) : (
                  c.label
                )}
              </div>
            </React.Fragment>
          ))}
        </div>
        <div className="step-tips step-tips-style">
          <span></span>
          {paragraphsSettings.caseDesc[activeKey]}
        </div>
        {/* =====  步骤卡片  ===== */}
        <div className="measure-tabs-list">
          {activeCase?.data?.map((s) => (
            <div key={s.num} className="card">
              <div className="left">
                <span className="left-num">
                  {String(s.num).padStart(2, '0')}
                </span>
                <span className="left-title">{s.title}</span>
              </div>
              <div className="right">
                <div className="right-list">
                  {s.list.map((t, i) => (
                    <div className="right-list-item" key={i}>
                      {i + 1}. {t}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {activeKey === '3' && clickCase && (
        <div className="measure-tabs-desc">
          <div className="measure-tabs-desc-title">
            {paragraphsSettings.case3Title}
          </div>
          <div className="measure-tabs-desc-subTitle">
            {paragraphsSettings.case3Desc}
          </div>
          <div className="measure-tabs-desc-content">
            <div>{paragraphsSettings.case3Content1}</div>
            <div className="mt">{paragraphsSettings.case3Content2}</div>
          </div>
          <img
            className="measure-tabs-desc-icon"
            onClick={() => setClickCase(false)}
            src={icon}
            alt=""
          />
        </div>
      )}
      <div
        id="education-cybersecurity-section2-question"
        className="topic-quiz"
      >
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          onCompleted={() => {
            setState({ ...state, quiz: true });
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'education-cybersecurity-section2-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section1;
